import { Component } from 'react';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { getTextColor } from 'MeetingsBase/utils/color';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCardContainer = styled.div.withConfig({
  displayName: "ColoredCard__StyledCardContainer",
  componentId: "cvtowz-0"
})(["background-color:", ";background-image:none;color:", ";height:100%;"], props => props.backgroundColor, props => props.textColor);
export default class ColoredCard extends Component {
  constructor(...args) {
    super(...args);
    this.getPrimaryColorToUse = () => {
      const {
        branding: {
          primaryColor
        }
      } = this.props;
      return primaryColor;
    };
    this.getTextColorToUse = () => {
      const {
        branding: {
          primaryColor
        }
      } = this.props;
      return getTextColor(primaryColor);
    };
  }
  render() {
    const {
      children,
      isSalesStarter
    } = this.props;
    const primaryColorToUse = this.getPrimaryColorToUse();
    const textColorToUse = this.getTextColorToUse();
    return /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsx(StyledCardContainer, {
        backgroundColor: primaryColorToUse,
        textColor: textColorToUse,
        children: /*#__PURE__*/_jsx(CardSection, {
          marginBlockEnd: "100",
          paddingInline: "0",
          paddingBlock: isSalesStarter ? '1100' : '800',
          display: "flex",
          flexDirection: "column",
          flex: "1",
          justifyContent: "center",
          children: /*#__PURE__*/_jsx(TFlex, {
            paddingBlockEnd: "100",
            direction: "column",
            justifyContent: "center",
            children: children
          })
        })
      })
    });
  }
}